import {Injectable, Injector, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {SessionObject} from '@twpub/core/models';
import {SESSION_STORAGE} from '@ng-web-apis/common';
import {NGXLogger} from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private sessionStorage: Storage | undefined;

  constructor(injector: Injector, private logger: NGXLogger) {
    this.logger.trace('SessionService.constructor silent:', {})
    if (isPlatformBrowser(injector.get(PLATFORM_ID))) {
      this.sessionStorage = injector.get<Storage>(SESSION_STORAGE);
    }
    const storedSession = this.sessionStorage?.getItem('sessionObj');
    const initialSession = storedSession ? JSON.parse(storedSession) : this.createDefaultSession();
    this.setSession(initialSession);
  }

  getSession(): SessionObject {
    const storedSession = this.sessionStorage?.getItem('sessionObj');
    return storedSession ? JSON.parse(storedSession) : this.createDefaultSession();
  }

  setSession(sessionObj: SessionObject) {
    this.sessionStorage?.setItem('sessionObj', JSON.stringify(sessionObj));
    this.logger.trace('SessionService.setSession: Persisted', sessionObj);
  }

  createDefaultSession(locale: string = 'en'): SessionObject {
    return new SessionObject({locale});
  }
}
